module.exports = __webpack_public_path__ + "img/icon_3_25.1de24331.png";